import {
  GET_CREDIT_NOTE_EMAIL_REQUEST,
  GET_CREDIT_NOTE_EMAIL_SUCCESS,
  GET_CREDIT_NOTE_EMAIL_ERROR
  } from "../actions/types";

  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_CREDIT_NOTE_EMAIL_REQUEST:
        return {
          loading: true,
        };
      case GET_CREDIT_NOTE_EMAIL_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_CREDIT_NOTE_EMAIL_ERROR:
        return {
          ...state,
          loading: false,
        };
      default:
        return state;
    }
  }
  